import TEXT from './generated/TEXT/constants';

export const MAX_INVOICE_COUNT = 18;

export enum Modifier {
  STORAGE_LIMIT = 'storage_limit',
  ARCHIVED_STORAGE_LIMIT = 'archived_storage_limit',
  MOUNTED_STORAGE_LIMIT = 'mounted_storage_limit',
  USER_LIMIT = 'user_limit',
  MEMBER_LIMIT = 'member_limit',
}

export const storageModifers = new Set([
  Modifier.STORAGE_LIMIT,
  Modifier.ARCHIVED_STORAGE_LIMIT,
  Modifier.MOUNTED_STORAGE_LIMIT,
]);

TEXT.DEFINE({
  /** Add-on type labels displayed in billing and plan summaries */
  addOnLabels: {
    /** Label for archival storage add-on */
    archivalStorage: 'Archival storage',
    /** Label for mounted storage add-on */
    mountedStorage: 'Mounted storage',
    /** Label for active storage add-on */
    storage: 'Storage',
    /** Label for user/member add-on */
    member: 'Member',
    /** Label for team seat add-on */
    teamSeat: 'Team Seat',
  },
});

export type AddOnTitleParams = {
  increment: number;
  modifier: Modifier;
  quantity: number;
};

export const addOnLabel: Record<string, string> = {
  get [Modifier.ARCHIVED_STORAGE_LIMIT]() {
    return TEXT.addOnLabels.archivalStorage;
  },
  get [Modifier.MOUNTED_STORAGE_LIMIT]() {
    return TEXT.addOnLabels.mountedStorage;
  },
  get [Modifier.STORAGE_LIMIT]() {
    return TEXT.addOnLabels.storage;
  },
  get [Modifier.USER_LIMIT]() {
    return TEXT.addOnLabels.member;
  },
  get [Modifier.MEMBER_LIMIT]() {
    return TEXT.addOnLabels.teamSeat;
  },
};

export const modifierSortOrderIndices: Record<string, number> = {
  plan: 0,
  user_limit: 1,
  member_limit: 2,
  storage_limit: 3,
  archived_storage_limit: 4,
  mounted_storage_limit: 5,
};
